import { createContext } from 'react';
import type { AuthContextType } from './authTypes';

// Context object for authentication; kept in separate module to satisfy fast refresh
export const AuthContext = createContext<AuthContextType | undefined>(undefined);
